import {
  osVersion,
  osName,
  browserVersion,
  browserName,
  mobileVendor,
  mobileModel,
  getUA,
  deviceType,
} from 'react-device-detect';

export const useDevice = () => {
  return {
    device: `${osName} ${osVersion}`,
    osVersion,
    osName,
    browserVersion,
    browserName,
    mobileVendor,
    mobileModel,
    userAgent: getUA,
    deviceType,
  }
};
